import { getToken, logger } from '@/lib';

const logFPTIWhenUpgradeOptionSubmitted = () => {
  logger.fpti('wps_upgrade_agree_and_create_account_submitted', {
    context: getToken(),
    context_type: 'WPS-Token',
    state_name: 'Create_account',
    transition_name: 'agree_and_create_account_submitted',
  });
};

const logFPTIWhenGuestOptionSubmitted = () => {
  logger.fpti('wps_upgrade_not_now_submitted', {
    context: getToken(),
    context_type: 'WPS-Token',
    state_name: 'Create_account',
    transition_name: 'not_now_submitted',
  });
};

const logFPTIWhenInterstitialClosed = () => {
  logger.fpti('wps_upgrade_create_account_interstitial_closed', {
    context: getToken(),
    context_type: 'WPS-Token',
    state_name: 'Create_account',
    transition_name: 'create_account_interstitial_closed',
  });
};

const logFPTIWhenInterstitialEligible = () => {
  logger.fpti('wps_upgrade_create_account_interstitial_eligible', {
    context: getToken(),
    context_type: 'WPS-Token',
    state_name: 'Create_account',
    transition_name: 'wps_upgrade_interstitial_eligible',
  });
};

const logFPTIWhenInterstitialInEligible = () => {
  logger.fpti('wps_upgrade_create_account_interstitial_ineligible', {
    context: getToken(),
    context_type: 'WPS-Token',
    state_name: 'Create_account',
    transition_name: 'wps_upgrade_interstitial_ineligible',
  });
};

const logFPTIWhenOpenInterstitialShown = () => {
  logger.fpti('wps_upgrade_upgrade_interstitial_shown', {
    context: getToken(),
    context_type: 'WPS-Token',
    state_name: 'Create_account',
    transition_name: 'create_account_render',
  });
};

export {
  logFPTIWhenGuestOptionSubmitted,
  logFPTIWhenInterstitialClosed,
  logFPTIWhenOpenInterstitialShown,
  logFPTIWhenUpgradeOptionSubmitted,
  logFPTIWhenInterstitialEligible,
  logFPTIWhenInterstitialInEligible,
};
